import i18n from '@/plugins/i18n'

const RIGHT_TO_LEFT_LANGS = ['ar']

const getCurrencySymbolKeyByCurrency = (currency) => {
  return `currency_symbol_${currency}`.toLocaleLowerCase()
}

const translateWithFallback = (key, params = {}, fallbackMessage = '') => {
  // The message was not found by the key, return fallbackMessage
  if (!i18n.te(key)) {
    return fallbackMessage
  }

  return i18n.t(key, params)
}

const isFetchedLocaleMessage = (module, locale, mapping) => {
  const key = `${module}_${locale}`

  return mapping[key] ?? false
}

const normalizeLocale = (locale) => {
  if (!TypeChecker.isString(locale)) {
    return 'ar_SA'
  }

  const [lang] = locale.replace('-', '_').split('_')
  const targetLang = lang || 'ar'

  return (
    {
      ar: 'ar_SA',
      en: 'en_US',
    }[targetLang] || 'ar_SA'
  )
}

export {
  RIGHT_TO_LEFT_LANGS,
  getCurrencySymbolKeyByCurrency,
  translateWithFallback,
  isFetchedLocaleMessage,
  normalizeLocale,
}
